<template>
  <v-card flat>
    <v-toolbar class="custom-bg" density="compact">
      <v-toolbar-title>Status</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-autocomplete
        :items="statuses"
        :label="$t('status')"
        v-model="status"
        @update:model-value="$nextTick(() => $emit('change', { status: $event }))"
        variant="underlined"
      />
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { tm } = useI18n()
const props = defineProps({
  workOrder: {
    type: Object,
    required: true
  }
})

const status= ref(null)
const statuses= ref([] as any[])

onMounted (() => {
  initializeInputs()
})
const initializeInputs = () => {
  status.value = props.workOrder.status ? props.workOrder.status : null
  statuses.value = Object.keys(tm('workOrderStatuses')).map((key, index) => {
    return {
      value: key,
      title: Object.values(tm('workOrderStatuses'))[index],
      disabled: false
    }
  }).filter(status => ['DRAFT', 'CLOSED'].indexOf(status.value) === -1)

  if(status.value !== 'APPROVED') {
    statuses.value = statuses.value.filter(status => status.value !== 'APPROVED')
  }
}

defineExpose({
  initializeInputs
});
</script>
